import Icon from '../components/Icon.vue'

Icon.register({
  'chess-queen': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 112c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56zM432 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-352c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h352zM504.9 184.2c3.9 2.6 7.1 8.6 7.1 13.3 0 2.1-0.8 5.3-1.7 7.2l-102.5 211.4h-303.5l-102.5-211.3c-0.9-1.9-1.7-5.1-1.7-7.2 0-4.7 3.2-10.7 7.1-13.3l28.6-16c7.4-4.9 16.8-2.5 22.1 4.5 7.9 10.6 25 19.3 38.2 19.3 0.9 0 2.4-0.1 3.3-0.1 25.7-1.7 44.7-24.8 44.7-50.5 0-7.4 6-13.4 13.4-13.4v0h38.8c6 0 11.6 4 12.9 9.9 4.4 21 25.5 38.1 47 38.1s42.5-17.1 47-38.1c1.3-5.9 6.9-9.9 12.9-9.9h38.8c7.4 0 13.4 6 13.4 13.4 0 23.5 15.7 45.5 38.8 49.8 2.5 0.5 6.6 0.9 9.1 0.9 13.2 0 30.2-8.6 38.1-19.1 5.4-7.1 14.8-9.7 22.3-4.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess-queen.js
// module id = 1185
// module chunks = 0